import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

const baseString = 'vra-script-flow-progress';
const ScriptFlowProgress = ({
  currentStep,
  numSteps
}) => {

  const classString = classNames({
    [`${baseString}`]: true
  });

  const style = {
    width: `${(currentStep / numSteps) * 100}%`
  };

  return (
    <section className={classString}>
      <span
        className={`${baseString}__shader`}
        style={style}>
        step {currentStep}
      </span>
    </section>
  );
};
ScriptFlowProgress.propTypes = {
  currentStep: propTypes.number.isRequired,
  numSteps: propTypes.number.isRequired
};
export default ScriptFlowProgress;
